import PaymentStatusSection from "../../components/NewDesign/Payment/PaymentStatusSection/PaymentStatusSection"

const PaymentStatusB2CPage = () => {

    return (
        <PaymentStatusSection />
    )
}

export default PaymentStatusB2CPage